var $a6a1af5968159b55$exports = {};
$a6a1af5968159b55$exports = {
  "breadcrumbs": "\u0130\xE7erik haritalar\u0131"
};
export { $a6a1af5968159b55$exports as default };